<app-global-loading *ngIf="loading"></app-global-loading>

<app-open-refund-panel
  *ngIf="order && !loading"
  [order]="order"
  [detail]="detail"
></app-open-refund-panel>
